// @ts-nocheck
import { mixins } from 'sonata-react-components';
import styled from 'styled-components';

const CampaignsListStyle = styled.section`
  margin: 0 auto;
  width: 100%;
  .reportingCampaignListContainer {
    &__containerSwitch {
      background: rgba(245,249,249,0.8);
      border: 1px solid #E5ECF1;
    }
    &__wrapperSwitch {
      margin: 0 auto;
      padding: 0 10px;
    }
    &__switch {
      display: flex;
      font-family: OpenSansSemiBold, serif;
      height: 32px;
    }
    &__tableContainer {
      background: #FFFFFF;
      border-bottom: 1px solid #E5ECF1;
    }
    &__wrapperTable {
      display: flex;
      justify-content: center;
      margin: 0 auto;
    }
    &__contentTable {
      padding: 8px 10px 16px 10px;
      width: 100%;
    }
    &__button {
      background: rgba(245,249,249,0.6);
      border-radius: 4px;
      height: 36px;
      margin-top: 8px;
      text-align: center;
    }
  }
  .reportingCampaignList {
    max-height: 590px;
    overflow-y: scroll;
    ${mixins.forceScrollbar}
    tr td {
      padding: 0;
      font-size: 14px;
    }
    td, th {
      gap: 16px;
      &.reportingCampaignList__campaignListHeader,
      &.reportingCampaignList__campaignListContent {
        &--name {
          flex: 1 1 440px;
        }
        &--regular {
          &--dates {
            flex: 1 1 160px;
          }
          &--pricing {
            justify-content: right;
            flex: 1 1 80px;
          }
          &--ad-format {
            justify-content: right;
            flex: 1 1 80px;
          }
          &--goalType {
            flex: 1 1 60px;
          }
          &--country {
            flex: 1 1 60px;
          }
        }
        &--advertiser {
          flex: 1 1 80px;
          > div {
            > span {
              display: flex;
              max-width: 110px;
            }
          }
        }
        &--bold {
          &--budget {
            justify-content: right;
            flex: 1 1 60px;
          }
          &--goal {
            justify-content: right;
            flex: 1 1 40px;
          }
        }
        &--button {
          justify-content: flex-end;
          margin-left: 8px;
          flex: 1 1 0;
        }
      }
      &.reportingCampaignList__campaignListContent {
        &--name {
          color: ${props => props.theme.uiColors.textBodyDefault};
          font-family: OpenSansSemiBold, serif;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
          >div {
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
          }
        }
        &--regular {
          &--dates, &--pricing, &--goalType {
            color: #505969;
            font-family: OpenSansRegular, serif;
            > div {
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
            }
          }
          &--pricing {
            justify-content: right;
          }
          &--ad-format {
            justify-content: right;
          }
        }
        &--bold {
          &--goal, &--budget {
            color: #505969;
            font-family: OpenSansSemiBold, serif;
            > div {
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
            }
          }
        }
      }
    }
    thead {
      tr {
        gap: 16px;
        th {
          color: #617EB5;
        }
      }
    }
    tbody {
      tr {
        align-items: center;
        gap: 16px;
      }
    }
    table {
      min-width: 1370px;
      overflow: hidden;
    }
  }
  .table__button {
    padding: 0;
    >.buttonWrapper__iconWrapper {
      padding-right: 0;
    }
  }
  .checkboxWrapper .checkboxText {
    font-size: 12px;
    margin-left: 8px;
  }
`;

export { CampaignsListStyle };
